import { Link } from "react-router-dom";
import { siteInfo } from "@/mocks/site";
import { topics } from "@/mocks/topics";

export default function HeroSection() {
  const featured = topics[0];
  const secondary = topics[2];

  return (
    <section className="relative overflow-hidden border-b border-background-200 bg-background-100/50">
      <div className="pointer-events-none absolute -right-24 -top-24 h-72 w-72 rounded-full bg-primary-100/60 blur-3xl" />
      <div className="pointer-events-none absolute -bottom-32 left-1/3 h-72 w-72 rounded-full bg-secondary-100/60 blur-3xl" />

      <div className="relative mx-auto grid w-full max-w-[1440px] grid-cols-1 items-center gap-10 px-4 py-12 md:px-8 md:py-20 lg:grid-cols-12">
        <div className="lg:col-span-6 animate-fade-up">
          <span className="inline-flex items-center gap-2 rounded-full border border-primary-200 bg-primary-50 px-3 py-1 text-xs font-medium text-primary-700">
            <i className="ri-stack-line text-sm" />
            独家吃瓜合集 · 每日整理
          </span>
          <h1 className="mt-5 font-heading text-3xl font-black leading-[1.2] text-foreground-950 md:text-[42px]">
            一个话题，
            <span className="text-primary-600">一次看完整合</span>
          </h1>
          <p className="mt-5 max-w-xl text-sm leading-relaxed text-foreground-600 md:text-base">
            {siteInfo.name}把零散的热点话题整理成有头有尾的独家吃瓜精选专题。不用再翻聊天记录，
            打开目录就能顺着时间线，把独家吃瓜全集一次看够。
          </p>

          <div className="mt-7 flex flex-col gap-3 sm:flex-row">
            <Link
              to="/topics"
              className="inline-flex h-11 items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              浏览专题合集
              <i className="ri-arrow-right-line" />
            </Link>
            <Link
              to="/rankings"
              className="inline-flex h-11 items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-6 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700"
            >
              看盘点榜单
            </Link>
          </div>

          <dl className="mt-10 grid grid-cols-2 gap-6 border-t border-background-200 pt-6 sm:grid-cols-4">
            {siteInfo.stats.map((stat) => (
              <div key={stat.label}>
                <dt className="text-xs text-foreground-500">{stat.label}</dt>
                <dd className="mt-1 font-heading text-xl font-bold text-foreground-950 md:text-2xl">
                  {stat.value}
                </dd>
              </div>
            ))}
          </dl>
        </div>

        <div className="lg:col-span-6 animate-fade-up delay-2">
          <div className="grid grid-cols-1 gap-4 sm:grid-cols-5">
            <Link
              to={`/topics/${featured.id}`}
              className="group relative col-span-1 block overflow-hidden rounded-lg border border-background-200 bg-background-50 sm:col-span-3"
            >
              <div className="h-56 w-full overflow-hidden bg-background-200 sm:h-72">
                <img
                  src={featured.cover}
                  alt={`${featured.title}专题封面`}
                  className="h-full w-full object-top transition-transform duration-500 group-hover:scale-[1.04]"
                />
              </div>
              <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/75 to-transparent p-4 pt-12">
                <span className="inline-block rounded-full bg-accent-500 px-2.5 py-1 text-[11px] font-medium text-background-50">
                  本期精选
                </span>
                <h2 className="mt-2 font-heading text-base font-bold leading-snug text-white md:text-lg">
                  {featured.title}
                </h2>
                <p className="mt-1 flex items-center gap-3 text-[11px] text-white/80">
                  <span>{featured.date}</span>
                  <span>{featured.readTime}</span>
                  <span>{featured.views} 阅读</span>
                </p>
              </div>
            </Link>

            <Link
              to={`/topics/${secondary.id}`}
              className="group relative col-span-1 block overflow-hidden rounded-lg border border-background-200 bg-background-50 sm:col-span-2"
            >
              <div className="h-56 w-full overflow-hidden bg-background-200 sm:h-72">
                <img
                  src={secondary.cover}
                  alt={`${secondary.title}专题封面`}
                  className="h-full w-full object-top transition-transform duration-500 group-hover:scale-[1.04]"
                />
              </div>
              <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/75 to-transparent p-4 pt-12">
                <span className="inline-block rounded-full bg-secondary-500 px-2.5 py-1 text-[11px] font-medium text-background-50">
                  {secondary.category}
                </span>
                <h2 className="mt-2 font-heading text-sm font-bold leading-snug text-white md:text-base">
                  {secondary.title}
                </h2>
              </div>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}